module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"join_request":"Join request","already_registered":"Your company is already registered as follows:","back_to_sign_in":"Back to sign in","message_template":"You can request to company\u0027s administrator to join your account","success_message":"Invitation request sent to administrator","tenant_not_exists":"Tenant not found"}}')
  delete Component.options._Ctor
}
